import React from 'react';
import { Button, Icon } from 'antd';

import { getLayerUrl } from 'helpers/userrequestHelpers';

class ExportFile extends React.Component {
  handleClick = async () => {
    const { layerId } = this.props;
    const downloadLink = await getLayerUrl(layerId);
    if (downloadLink) {
      global.location = downloadLink;
    }
  }

  render () {
    return (
      <Button style={{ marginRight: 10 }} onClick={this.handleClick}>
        <Icon type="download" theme="outlined" /> Exporter un fichier
      </Button>
    );
  }
}

export default ExportFile;



// WEBPACK FOOTER //
// ./src/components/Admin/UploadFiles/ExportFile.js